import { render } from "./abort-voting-modal.vue?vue&type=template&id=5cd2dccd"
import script from "./abort-voting-modal.vue?vue&type=script&lang=js"
export * from "./abort-voting-modal.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__